import {hasPermission, useUser} from "../../../../misc/Permission";
import {BoolCol, RenderStringCol, StringCol, Table, ViewOnly} from "../../../../misc/scroller/Table";
import {priceTableName} from "./Pricing";
import {useProjectId, useProjectUnitSystem} from "../ProjectName";
import {formatSmallUnits} from "../../../../misc/DimFormat";
import React, {useContext} from "react";
import {ManagerLockContext} from "../ProjectActions";
import {PriceLine2} from "./Frames";
import {commonPricingColumns3, sovCellCustomize, sovColumns, usePricingKit2} from "./usePricingKit2";
import {getAll} from "../../../logistics/routes/useGetAll";
import {api} from "../../../../api/API";
import {onPricingChangeWrap} from "./PricingTabs";
import {useCheckboxExtSetupData} from "../../manage/sov/CheckboxExtProvider";

// Glass pricing in project mode. Glass carries no preps, so this is the plain price grid over
// the glazing properties the panel is identified by.
export function Glazing(props: {
    filterByChangeset?: boolean;
    sov?: number;
}) {
    const project = useProjectId();
    const {locked} = useContext(ManagerLockContext);
    const u = useUser();

    const kit = usePricingKit2(project);
    const checkboxAllData = useCheckboxExtSetupData();

    const sys = useProjectUnitSystem();
    if(!sys) return null;
    if(!u) return null;
    if(kit.Loading) return <>{kit.Loading}</>

    return (
        <Table<PriceLine2>
            name={priceTableName(project, "glazing")}
            globalPrefsName={priceTableName(0, "glazing")}
            cellCustomize={props.sov ? sovCellCustomize(props.sov) : kit.cellCustomize}
            locked={locked && !hasPermission(u, "EditShopDrawingWhenLockedToManager")}
            fetch={async (ctx) => checkboxAllData(getAll(ctx, offset =>
                api.pricing.list({
                    project: project, offset,
                    previewChangeset: kit.sessionId,
                    category: "glazing",
                    refunded: props.filterByChangeset ? false : undefined,
                    filterByChangeset: props.filterByChangeset,
                    forSovLink: !!props.sov,
                })
            ))}
            columns={[
                ...sovColumns(props.sov),
                ViewOnly(StringCol("Type", "glass.type", 100)),
                RenderStringCol<PriceLine2>("Thickness",
                    (dt) => formatSmallUnits(dt.glass?.thickness, sys), 90),
                ViewOnly(BoolCol("Thermal", "glass.thermal", 80)),
                ViewOnly(StringCol("Bead", "glass.bead", 100)),
                ViewOnly(StringCol("Width", "glass.width", 90)),
                ViewOnly(StringCol("Height", "glass.height", 90)),
                ...commonPricingColumns3(u, kit.markup?.frame + "%", props.sov),
            ]}
            columnDeps={[u, kit.markup, props.sov, sys]}
            fetchDeps={[project, kit.sessionId, props.sov]}
            onChange={(input) => onPricingChangeWrap(api.pricing.upsert(input))}
        />
    )
}
